import React from 'react';
import Radio from './Radio';

const CustomCheckbox = ({ shape, color, label, selected, onClick }) => {
	return (
		<React.Fragment>
			<div
				id="CustomCheckbox"
				className={`p-4s mb-3s d-flex align-items-center pointer ${selected ? 'selected' : ''}`}
				onClick={() => onClick()}
			>
				<Radio
					shape={shape || 'checkbox'}
					color={color}
					selected={selected}
					height={18}
				/>
				<span className={`ml-2 fs-14 ${selected ? 'fw-500s' : ''}`}>
					{label}
				</span>
			</div>
		</React.Fragment>
	);
};

export default CustomCheckbox;
